import * as ActionTypes from 'actions/partnerPlanForm'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
}

// Updates error message to notify about the failed fetches.
export default function partnerPlanForm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLAN_SAVE_REQUEST:
      return Object.assign({}, state, {
        // isFetching: true,
      })
    case ActionTypes.PARTNERPLAN_SAVE_COMPLETE:
      return {
        ...state,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlanForm.js